<template>
  <div class="animated fadeIn">
    <Tables ref="tableGrid"
      :columns="['Cartão', 'Produto', 'Situacao', 'Limite Atribuido', 'Limite Disponivel', 'Limite Utilizado', 'Função', 'Bandeira']"
      :showTipFooter="false"
      v-on:Load="onLoad">
      <tr v-for="obj in this.objList" v-bind:key="obj.id">
        <TableColumn :IsText="true" :status="1" :value="obj.id ? obj.numeroCartao.toString() : ''"/>
        <TableColumn :IsText="true" :status="1" :value="obj.produtoCartao ? obj.produtoCartao.toString() : ''"/>
        <TableColumn :IsText="true" :status="1" :value="obj.situacao" />
        <TableColumn :IsText="true" :status="1" :value="obj.limiteAtribuido ? formatValue(obj.limiteAtribuido) : 'R$ 0,00'" />
        <TableColumn :IsText="true" :status="1" :value="obj.limiteDisponivel ? formatValue(obj.limiteDisponivel) : 'R$ 0,00'" />
        <TableColumn :IsText="true" :status="1" :value="obj.limiteUtilizado ? formatValue(obj.limiteUtilizado) : 'R$ 0,00'" />
        <TableColumn :IsText="true" :status="1" :value="obj.funcao" />
        <TableColumn :IsText="true" :status="1" :value="obj.bandeira" />
      </tr>
    </Tables>
  </div>
</template>
<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import { loading } from '@/shared/utils/UIHelper'
import BankCheckRepository from '@/shared/http/repositories/business/creditcard.js'
import Tools from '@/components/tools/Tools.js'

export default {
  name: 'CreditCard',
  mixins: [ActionsForm],
  data () {
    return {
      document: null
    }
  },
  methods: {
    onLoad () {
      if (this.document) {
        this.onLoadCreditCard(this.document)
      }
    },
    onLoadCreditCard (document) {
      loading.push()
      this.document = document
      BankCheckRepository.Search(document, this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex)
        .then((response) => {
          this.onResultGrid(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    formatValue (value) {
      let result
      if (value) {
        result = Tools.formatMoneyBR(value.toString())
      }
      return result
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/associate/tabs/creditcard.vue